import {Store} from '@tanstack/react-store'
import type {
  V2FormRequest,
  V2FormResponse,
} from '@yandex-delivery/types/schemas/services/delivery-corp-account-api/docs/yaml/definitions/delivery_form'

import type {VerticalBduiParams} from 'src/shared/types'

import {initialRequest} from '../consts'

type StoreState = {
  ttl?: number
  descriptors: V2FormResponse['descriptors']
  formRequest: Omit<V2FormRequest, 'mode'>
  offerId?: string
  settings?: VerticalBduiParams
}

export const store = new Store<StoreState>({
  descriptors: [],
  formRequest: initialRequest,
  settings: undefined,
})
